<template>
  <div>
    <v-card flat color="transparent">
      <!-- For all kinds of product -->
      <SingleProductOrder
        v-if="!multiProductsOrder"
        :selectedProduct="selectedProduct"
        @book="onSingleBookBtnClick"
      />

      <!-- For rental products -->
      <MultipleProductsOrder
        v-else
        :productList="productList"
        @book="onMultiBookBtnClick"
      />
    </v-card>

    <!-- Dialog to check user's age -->
    <ProductAgeAlert
      v-model="showAgeAlert"
      :forAge="selectedProduct.ForAge"
      @confirm="triggerShoppingListOrCard"
    />

    <!-- Dialog to confirm if user wants to select more Rental products -->
    <v-dialog v-model="rentalDialog" max-width="500">
      <v-card>
        <v-card-title>
          {{ $translate('RENTAL_DIALOG_TITLE') }}
        </v-card-title>
        <v-card-text v-html="addMoreRentalProdMsg" />
        <v-card-actions>
          <v-btn
            color="primary"
            class="primary-font-color"
            @click="onEnableMultiSelection"
          >
            {{ $translate('PRODUCTS_ADD_MORE') }}
          </v-btn>
          <v-spacer />
          <v-btn
            color="secondary"
            @click="checkTheProductAge(shoppingCartFlow)"
          >
            {{ $translate('CONTINUE') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import doRequest from '@/api/dssRequest';
import uiHelpers from '@/shared/ui_helpers';
import { SHOPPING_CONTAINER } from '@/shared/constants';
import utility from '@/shared/utility';
import SingleProductOrder from '@/components/event/eventDetails/productOrderComponents/SingleProductOrder';
import MultipleProductsOrder from '@/components/event/eventDetails/productOrderComponents/MultipleProductsOrder';
import ProductAgeAlert from '@/components/event/eventDetails/productOrderComponents/ProductAgeAlert';
import { addProductToReservation } from '@/objects/ShoppingList';

const SHOPPING_LIST_FLOW = 'shoppingListFlow';
const SHOPPING_CART_FLOW = 'shoppingCartFlow';

export default {
  name: 'ProductOrder',
  mixins: [uiHelpers],
  components: {
    SingleProductOrder,
    MultipleProductsOrder,
    ProductAgeAlert,
  },
  props: {
    selectedProduct: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isWeightedProduct() {
      if (
        this.selectedProduct != null &&
        this.selectedProduct.Type === 'Weighted'
      ) {
        return true;
      }

      return false;
    },
    category() {
      if (
        this.selectedProduct != null &&
        this.selectedProduct.Categories != null &&
        this.selectedProduct.Categories.length > 0
      ) {
        return this.selectedProduct.Categories[0];
      }
      return {};
    },
    addMoreRentalProdMsg() {
      return utility.sprintf(
        this.$translate('RENTAL_DIALOG_DESC'),
        this.category.Name
      );
    },
  },
  watch: {
    selectedProduct() {
      this.init();
    },
  },
  data() {
    return {
      selectedFlow: '',
      showAgeAlert: false,
      multiProductsOrder: false,
      productList: [],
      rentalDialog: false,

      // Order flow
      shoppingListFlow: SHOPPING_LIST_FLOW,
      shoppingCartFlow: SHOPPING_CART_FLOW,

      selectedItem: {},
      selectedShoppingList: {},
      quantity: 1,

      selectedRentalProducts: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.quantity = 1;
      this.multiProductsOrder = false;
      this.selectedRentalProducts = [];
      this.getProductsByCategory();
    },
    checkTheProductAge(flow) {
      this.selectedFlow = flow;
      const lowestAge = 0;
      if (
        this.selectedProduct != null &&
        this.selectedProduct.ForAge > lowestAge
      ) {
        this.showAgeAlert = true;
        return;
      }

      if (flow === this.shoppingListFlow) {
        this.addToShoppingList();
      } else {
        this.addToCart();
      }
    },
    addToShoppingList() {
      this.selectedFlow = '';
      this.showAgeAlert = false;

      let orderId = '';

      if (
        this.selectedShoppingList.OrderGroup != null &&
        this.selectedShoppingList.OrderGroup.Orders != null
      ) {
        const order = this.selectedShoppingList.OrderGroup.Orders.find(
          (orderInList) =>
            String(orderInList.EventId) === String(this.selectedProduct.EventId)
        );
        if (order != null) {
          orderId = order.OrderId;
        }
      }

      let createList = true;
      let shoppingListId = '';
      if (
        this.selectedShoppingList != null &&
        this.selectedShoppingList.ShoppingListId != null &&
        this.selectedShoppingList.ShoppingListId !== '' &&
        this.selectedShoppingList.ShoppingListId !== -1
      ) {
        shoppingListId = this.selectedShoppingList.ShoppingListId;
        createList = false;
      }

      const payload = {
        CreateShoppingList: createList,
        ShoppingListName: this.selectedShoppingList.ShoppingListName,
        ShoppingListId: shoppingListId,
        OrderId: orderId,
        EventId: this.selectedProduct.EventId,
        ProductId: this.selectedProduct.Id,
        ItemId: this.selectedItem.Id,
        Quantity: this.quantity,
        OptionSelection: this.getProductOptions(),
      };

      addProductToReservation(payload)
        .then(() => {})
        .catch(() => {});

      this.$emit('back');
    },
    addToCart() {
      this.selectedFlow = '';
      this.showAgeAlert = false;

      const productInfo = this.getProductForReserve();

      if (this.selectedProduct.Type === 'Rental') {
        this.rentalFlowReserve(productInfo);
      } else {
        this.reserve(productInfo);
      }

      this.$emit('back');
    },
    rentalFlowReserve(cartProduct) {
      this.$emit('book-rental-products', cartProduct);
    },
    reserve(cartProduct) {
      this.$store.commit('shoppingCart/addOrder', cartProduct);
    },
    checkProductListLength() {
      if (this.productList.length > 1) {
        this.rentalDialog = true;
      } else {
        this.checkTheProductAge(this.shoppingCartFlow);
      }
    },
    onSingleBookBtnClick(bookProps) {
      this.selectedShoppingList = { ...bookProps.ShoppingList };
      this.selectedItem = { ...bookProps.Item };
      this.quantity = bookProps.Quantity;

      /* For Rental product
      Go to event details page for rental product reservation */
      if (this.selectedProduct.Type === 'Rental') {
        if (this.$route.name !== 'ProductWithCategory') {
          this.goToPage('ProductWithCategory', {
            event_id: this.selectedProduct.EventId,
            category_id: this.selectedProduct.Categories[0].Id,
            product_id: this.selectedProduct.Id,
          });
        } else {
          this.checkProductListLength();
        }
        // to hide the menu if you go to an event for rental products
        window.EventBus.fire('hideSearchMenu');
        return;
      }

      // Non-rental product
      if (
        this.selectedShoppingList.ShoppingListId ===
        SHOPPING_CONTAINER.ShoppingCart
      ) {
        // Shopping cart selected
        this.checkTheProductAge(this.shoppingCartFlow);
      } else {
        this.checkTheProductAge(this.shoppingListFlow);
      }
    },
    onMultiBookBtnClick(bookProps) {
      this.selectedRentalProducts = [...bookProps.Products];
      this.checkTheProductAge(this.shoppingCartFlow);
    },
    triggerShoppingListOrCard() {
      if (this.selectedFlow === this.shoppingListFlow) {
        this.addToShoppingList();
      } else {
        this.addToCart();
      }
    },
    getProductForReserve() {
      if (this.selectedProduct.Type === 'Rental') {
        // Return Array for Rental product
        const prodArray = [];

        if (this.multiProductsOrder) {
          // Selected multiple rental products
          this.selectedRentalProducts.forEach((product) => {
            prodArray.push({
              EventType: product.EventType,
              EventId: product.EventId,
              Name: product.Name,
              Picture: product.PictureUrl,
              Id: product.Id,
              ItemId: product.Items[0].Id,
              ItemDefs: product.ItemDef,
              Type: product.Type,
              Price: product.Price,
              Quantity: product.Quantity,
              Product: product,
              Item: product.Items[0],
            });
          });
        } else {
          // Selected one rental product
          prodArray.push({
            EventType: this.selectedProduct.EventType,
            EventId: this.selectedProduct.EventId,
            Name: this.selectedProduct.Name,
            Picture: this.selectedProduct.PictureUrl,
            Id: this.selectedProduct.Id,
            ItemId: this.selectedItem.Id,
            ItemDefs: this.selectedItem.ItemDef,
            Type: this.selectedProduct.Type,
            Price: this.selectedItem.Price,
            Quantity: this.quantity,
            Product: this.selectedProduct,
            Item: this.selectedItem,
          });
        }

        return prodArray;
      }

      // Return Object for other types
      const prodInfo = {
        EventType: this.selectedProduct.EventType,
        EventId: this.selectedProduct.EventId,
        Name: this.selectedProduct.Name,
        Picture: this.selectedProduct.Picture,
        Id: this.selectedProduct.Id,
        ItemId: this.selectedItem.Id,
        ItemDefs: this.selectedItem.ItemDef,
        Type: this.selectedProduct.Type,
        Price: this.selectedItem.Price,
        Quantity: this.quantity,
        OptionSelection: this.getProductOptions(),
        Product: this.selectedProduct,
        Item: this.selectedItem,
      };

      if (this.isWeightedProduct) {
        // Add extra info for Weighted product
        prodInfo.Price =
          (this.quantity / this.selectedProduct.WeightedInfo.StepSize) *
          this.selectedProduct.WeightedInfo.PricePerStep;
        prodInfo.Amount = this.quantity;
        prodInfo.Quantity = 1;
        prodInfo.FixedPrice = this.selectedProduct.WeightedInfo.FixedPrice;
        prodInfo.Unit = this.selectedProduct.WeightedInfo.Unit;
        prodInfo.WeightedInfo = this.selectedProduct.WeightedInfo;
      }
      return prodInfo;
    },
    getProductOptions() {
      if (
        this.selectedProduct != null &&
        this.selectedProduct['OptionLists'] != null
      ) {
        let optionSelection = [];
        this.selectedProduct.OptionLists.forEach((list) => {
          if (list.OptionGroups != null) {
            list.OptionGroups.forEach((optionGroup) => {
              if (optionGroup.Options != null) {
                let options = optionGroup.Options;
                // optionSelection = [];
                for (const key in options) {
                  //if (list.Type === 'NumberResponse') {
                  let quantity =
                    options[key].MaxQuantity > 1 ||
                    options[key].MaxQuantity == -1
                      ? options[key].Quantity
                      : options[key].Selected
                      ? 1
                      : 0;
                  if (quantity > 0) {
                    let optSelection = {
                      OptionId: options[key].OptionId,
                      OptionName: options[key].OptionName,
                      Quantity: quantity,
                      TextResponse:
                        list.Type === 'NumberResponse'
                          ? ''
                          : options[key].TextResponse,
                      PictureResponse:
                        list.Type === 'NumberResponse'
                          ? ''
                          : options[key].PictureResponse,
                    };
                    if (list.Type === 'NumberResponse')
                      optionSelection.push(optSelection);
                    else {
                      if (
                        optSelection.TextResponse !== '' ||
                        optSelection.PictureResponse !== ''
                      ) {
                        optionSelection.push(optSelection);
                      }
                    }
                  }
                }
              }
            });
          }
        });
        return optionSelection;
      } else return [];
    },
    getProductsByCategory() {
      // For Rental products
      if (
        this.selectedProduct == null ||
        this.selectedProduct.Type == null ||
        this.selectedProduct.Type !== 'Rental'
      ) {
        return;
      }

      const payload = {
        ProductCategoryId: this.selectedProduct.Categories[0].Id,
      };

      const object = this.$store.getters['auth/userName']
        ? this.$store.getters['auth/userName']
        : this.$store.getters['auth/tmpUserId'];

      doRequest(
        (response) => {
          if (response.data.Products != null) {
            this.productList = response.data.Products;
            this.productList.forEach((item) => {
              item.Quantity = 0;
              if (this.selectedProduct.Id === item.Id) {
                item.Quantity = this.quantity;
              }
            });
          }
        },
        () => {},
        'getProductsByCategory',
        object,
        payload,
        'GET'
      );
    },
    onEnableMultiSelection() {
      // Update quantity of selected product in product list
      const initialProd = this.productList.find(
        (prod) => prod.Id === this.selectedProduct.Id
      );
      if (initialProd != null) {
        initialProd.Quantity = this.quantity;
      }

      this.multiProductsOrder = true;
      this.rentalDialog = false;
    },
  },
};
</script>
